(function() {
  var cartIcon = document.getElementById('cart-icon-bubble');
  if (!cartIcon) return;

  var popup = document.createElement('div');
  popup.id = 'soan-cart-hover';
  popup.innerHTML = '<div class="soan-cart-hover__inner"><p class="soan-cart-hover__loading">Chargement...</p></div>';
  document.body.appendChild(popup);

  var hideTimeout = null;
  var loaded = false;

  function showPopup() {
    clearTimeout(hideTimeout);
    var rect = cartIcon.getBoundingClientRect();
    popup.style.top = (rect.bottom + window.scrollY + 8) + 'px';
    popup.style.right = (window.innerWidth - rect.right) + 'px';
    popup.classList.add('soan-cart-hover--visible');
    if (!loaded) loadCart();
  }

  function hidePopup() {
    hideTimeout = setTimeout(function() {
      popup.classList.remove('soan-cart-hover--visible');
    }, 200);
  }

  function loadCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        loaded = true;
        renderCart(cart);
      })
      .catch(function() {
        popup.querySelector('.soan-cart-hover__inner').innerHTML = '<p style="padding:16px;color:#888;font-size:13px;">Impossible de charger le panier.</p>';
      });
  }

  function renderCart(cart) {
    var FREE_SHIPPING = 75;
    var total = cart.total_price / 100;
    var remaining = FREE_SHIPPING - total;
    var percent = Math.min((total / FREE_SHIPPING) * 100, 100);

    var shippingBar = remaining <= 0
      ? '<div class="soan-ch-shipping soan-ch-shipping--done"><span>\uD83C\uDF89 Livraison offerte\u00a0!</span><div class="soan-ch-bar"><div class="soan-ch-progress" style="width:100%;background:#2a7a2a"></div></div></div>'
      : '<div class="soan-ch-shipping"><span>\uD83D\uDE9A Plus que <strong>' + remaining.toFixed(2).replace('.', ',') + '\u20ac</strong> pour la livraison offerte</span><div class="soan-ch-bar"><div class="soan-ch-progress" style="width:' + percent + '%"></div></div></div>';

    var itemsHtml = '';
    if (cart.items && cart.items.length > 0) {
      itemsHtml = cart.items.slice(0, 3).map(function(item) {
        var price = (item.price / 100).toFixed(2).replace('.', ',') + '\u20ac';
        var img = item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '" class="soan-ch-item__img">' : '<div class="soan-ch-item__img soan-ch-item__img--empty"></div>';
        return '<div class="soan-ch-item">'
          + img
          + '<div class="soan-ch-item__info">'
          + '<p class="soan-ch-item__title">' + item.product_title + '</p>'
          + (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="soan-ch-item__variant">' + item.variant_title + '</p>' : '')
          + '<p class="soan-ch-item__price">x' + item.quantity + ' &mdash; ' + price + '</p>'
          + '</div></div>';
      }).join('');
      if (cart.items.length > 3) {
        itemsHtml += '<p class="soan-ch-more">+ ' + (cart.items.length - 3) + ' autre(s) article(s)</p>';
      }
    } else {
      itemsHtml = '<p class="soan-ch-empty">Votre panier est vide</p>';
    }

    var totalHtml = cart.items.length > 0
      ? '<div class="soan-ch-total"><span>Total</span><span class="soan-ch-total__price">' + (total).toFixed(2).replace('.', ',') + '\u20ac</span></div>'
        + '<a href="/cart" class="soan-ch-btn">Voir mon panier (' + cart.item_count + ')</a>'
      : '';

    popup.querySelector('.soan-cart-hover__inner').innerHTML =
      '<p class="soan-ch-title">Mon panier</p>'
      + shippingBar
      + '<div class="soan-ch-items">' + itemsHtml + '</div>'
      + totalHtml;
  }

  // Rafraîchit à chaque ouverture
  cartIcon.addEventListener('mouseenter', function() {
    loaded = false;
    showPopup();
  });
  cartIcon.addEventListener('mouseleave', hidePopup);
  popup.addEventListener('mouseenter', function() { clearTimeout(hideTimeout); });
  popup.addEventListener('mouseleave', hidePopup);

  // Rafraîchit après ajout au panier
  document.addEventListener('cart:updated', function() { loaded = false; });
})();
